import React from 'react'
import styles from './Spinner.module.scss'

interface SpinnerProps {
    size?: 'small' | 'medium' | 'large'
    message?: string
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'medium', message }) => {
    return (
        <div className={styles.spinnerContainer}>
            <div className={`${styles.spinner} ${styles[size]}`} />
            {message && <p className={styles.message}>{message}</p>}
        </div>
    )
}

